module.exports = __webpack_public_path__ + "img/recapBanner-part1.77fbcfb1.svg";